import styles from "./DatePicker.module.css";

type Props = {
  dateLabel: number;
  day: number;
  isAvailable: boolean;
  isSelected: boolean;
  onChange: (clickedDay: number) => void;
  id: string;
};

export default function DateButton(props: Props) {
  return (
    <div
      className={styles.dateButtonParent}
      style={{gridColumnStart: props.day + 1}}
    >
      <input
        className={styles.dateRadioButton}
        type="radio"
        disabled={!props.isAvailable}
        name="date"
        id={props.id}
        onChange={() => {
          props.onChange(props.dateLabel);
        }}
        checked={props.isSelected && props.isAvailable}
      />
      <label htmlFor={props.id} className={styles.dateButtonLabel}>
        {props.dateLabel}
      </label>
    </div>
  );
}
